<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <report-list-filter />
      <report-list-header />
      <report-list-table />
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReportList',
  computed: {
  }
}
</script>

<style>

</style>
